/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ModelError,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    VerifyUser,
    VerifyUserFromJSON,
    VerifyUserToJSON,
} from '../models';

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * ユーザーがログインしているかどうか
     * Verify User
     */
    async verifyUserRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<VerifyUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/verify_user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyUserFromJSON(jsonValue));
    }

    /**
     * ユーザーがログインしているかどうか
     * Verify User
     */
    async verifyUser(initOverrides?: RequestInit): Promise<VerifyUser> {
        const response = await this.verifyUserRaw(initOverrides);
        return await response.value();
    }

}
